import moment from 'moment';
import { SERVER_BASE_URL } from './http/apiEndpoints';
import { getApiServerBaseURL } from './http/getBaseURL';

const isToday = (date, format) =>
  moment(date, format)
    .startOf('day')
    .isSame(moment().startOf('day'));

const isTomorrow = (date, format) =>
  moment(date, format)
    .startOf('day')
    .isSame(
      moment()
        .add(1, 'days')
        .startOf('day'),
    );

const isNotPast = dateTime => moment(dateTime).isAfter(moment());

const getWeekDay = isoWeekday => {
  switch (isoWeekday) {
    case 0:
      return 'Sunday';
    case 1:
      return 'Monday';
    case 2:
      return 'Tuesday';
    case 3:
      return 'Wednesday';
    case 4:
      return 'Thursday';
    case 5:
      return 'Friday';
    case 6:
      return 'Saturday';
    default:
      return '';
  }
};

const getWeekDayShort = isoWeekday => {
  switch (isoWeekday) {
    case 0:
      return 'Sun';
    case 1:
      return 'Mon';
    case 2:
      return 'Tue';
    case 3:
      return 'Wed';
    case 4:
      return 'Thur';
    case 5:
      return 'Fri';
    case 6:
      return 'Sat';
    default:
      return '';
  }
};

const generateRandomNumber = (max = 100) => Math.floor(Math.random() * max) + 1;

const getTodayDate = () => new Date().toISOString().split('T')[0];

const titleCase = str => {
  const strArray = str.toLowerCase().split(' ');

  for (let i = 0; i < strArray.length; i++) {
    strArray[i] = strArray[i].charAt(0).toUpperCase() + strArray[i].slice(1);
  }
  return str.join(' ');
};

const getImageURL = relURL => {
  if (!relURL) return '';
  if (relURL.startsWith('http')) {
    return relURL;
  }
  return `${SERVER_BASE_URL}${relURL}`;
};

const getUserFullName = user => (user ? `${user.firstName} ${user.lastName}` : '');

const parseDataObj = dataObj => {
  const finalObj = { ...dataObj };
  Object.keys(finalObj).forEach(key => {
    const keySearchable = key.toLowerCase();
    const isDate = ['time', 'date', 'createdat', 'updatedat', 'lastmessagetime', 'creationtime', 'updationtime', 'alertTime', 'lastChecked', 'resolutionTime'].findIndex(val => keySearchable.includes(val)) !== -1;
    if (isDate) {
      finalObj[key] = new Date(finalObj[key]) || finalObj[key];
    }
  });

  return finalObj;
};

const packageDataObj = dataObj => {
  const finalObj = { ...dataObj };
  Object.keys(finalObj).forEach(key => {
    const value = finalObj[key];
    if (value instanceof Date) {
      finalObj[key] = value.getTime();
    }
  });

  return finalObj;
};

const getImageURLForFetch = imageUrl => {
  if (!imageUrl) return '';
  if (typeof imageUrl !== 'string' || imageUrl.startsWith('blob') || imageUrl.startsWith('http')) {
    return imageUrl;
  }
  return `${getApiServerBaseURL()}${imageUrl}`;
};

export function getEntitiesUUIdObj(array1, array2) {
  const helperObj = {};

  const putInObj = arr =>
    (arr || []).forEach(obj => {
      helperObj[obj.uuid] = obj;
    });
  putInObj(array1);
  putInObj(array2);

  return helperObj;
}

export function getUniqueEntitiesAfterMerge(array1, array2) {
  return Object.values(getEntitiesUUIdObj(array1, array2));
}

export const flattenInteractionsObj = (allInteractionsObj) => {
  const flatList = [];
  Object.keys(allInteractionsObj || {}).forEach(dmac => {
    flatList.push(...(allInteractionsObj[dmac].interactions || []));
  })
  flatList.sort((a ,b) => b.updationTime - a.updationTime);
  return flatList;
}

export const flattenRoomInteractions = (roomsData) => {
  const flatList = [];
  (roomsData || []).forEach(roomData => {
    ['alertInteraction', 'latestInteraction', 'temperatureMap', 'humidityMap'].forEach(type => {
      const interactionMap = roomData[type] || {};
      if (isEmptyObj(interactionMap)) {
        return;
      }
      Object.values(interactionMap).filter(isNotEmptyObj).forEach(obj => flatList.push(obj));
    })
  });
  flatList.sort((a ,b) => b.updationTime - a.updationTime);
  return flatList;
}

export const isEmptyArr = (arr) => {
  return Array.isArray(arr) ? !arr.length : true;
}

export const isEmptyObj = (obj) => {
  return typeof obj === "object" && obj ? !Object.keys(obj).length : true;
}

export const isNotEmptyObj = (obj) => !isEmptyObj(obj);

export {
  isToday,
  isTomorrow,
  getWeekDay,
  isNotPast,
  getWeekDayShort,
  generateRandomNumber,
  getTodayDate,
  titleCase,
  getImageURL,
  getUserFullName,
  parseDataObj,
  packageDataObj,
  getImageURLForFetch,
};
